import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

// Create a styled component for the footer
export const StyledFooter = styled(Box)(({ theme }) => ({
  padding: 20,
}));

const useStyles = () => ({
  footer: {
    paddingTop: 10,
    color: 'rgba(0, 0, 0, 0.35)',
  },
});

export default useStyles;